import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/icons/lightroom.svg'
import _imports_1 from '@/assets/images/icons/captureone.svg'


const _hoisted_1 = { class: "relative inline-flex" }
const _hoisted_2 = ["disabled", "aria-expanded", "aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "hidden sm:inline-block"
}
const _hoisted_4 = {
  key: 1,
  class: "shrink-0 size-4",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = ["onClick", "disabled"]
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "size-4",
  alt: "Copy to Lightroom"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "size-4",
  alt: "Copy to Capture One"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrashIcon = _resolveComponent("TrashIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      type: "button",
      class: _normalizeClass(_ctx.triggerClasses),
      disabled: _ctx.disabled,
      "aria-expanded": _ctx.isOpen,
      "aria-label": _ctx.triggerText || 'Dropdown menu'
    }, [
      (_ctx.triggerText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.triggerText), 1))
        : _createCommentVNode("", true),
      (_ctx.triggerIcon)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "1"
            }, null, -1),
            _createElementVNode("circle", {
              cx: "12",
              cy: "5",
              r: "1"
            }, null, -1),
            _createElementVNode("circle", {
              cx: "12",
              cy: "19",
              r: "1"
            }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.dropdownClasses),
      role: "menu",
      "aria-orientation": "vertical"
    }, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: option.id,
            onClick: ($event: any) => (_ctx.handleOptionClick(option)),
            type: "button",
            class: _normalizeClass(_ctx.getOptionClasses(option)),
            disabled: option.disabled
          }, [
            (option.icon == 'lightroom')
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true),
            (option.icon == 'captureone')
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            (option.icon == 'delete')
              ? (_openBlock(), _createBlock(_component_TrashIcon, {
                  key: 2,
                  class: "size-4"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(option.label), 1)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ], 2), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}